import { c as _c } from "react/compiler-runtime";
import { Flex, FlexColumn, NumberDisplay, Separator, TextBody, TextLabel } from "@opensea/ui-kit";
import { capitalize } from "es-toolkit/compat";
import { useTranslations } from "use-intl";
export function SendReview(t0) {
  const $ = _c(45);
  const {
    quantity,
    quantityUsd,
    priceUSD,
    currency,
    total
  } = t0;
  const t = useTranslations("wallet.SendFlow");
  let t1;
  if ($[0] !== t) {
    t1 = t("review.title");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <TextLabel color="text-secondary" size="xs">{t1}</TextLabel>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = quantity || 0;
  let t4;
  if ($[4] !== t3) {
    t4 = <NumberDisplay value={t3} />;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== priceUSD) {
    t5 = <TextBody color="text-secondary"> @ <NumberDisplay display="usd" value={priceUSD} /></TextBody>;
    $[6] = priceUSD;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== currency.symbol || $[9] !== t4 || $[10] !== t5) {
    t6 = <TextBody>{t4} {currency.symbol}{t5}</TextBody>;
    $[8] = currency.symbol;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const t7 = quantityUsd || 0;
  let t8;
  if ($[12] !== t7) {
    t8 = <TextBody><NumberDisplay display="usd" value={t7} /></TextBody>;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t6 || $[15] !== t8) {
    t9 = <Flex className="justify-between">{t6}{t8}</Flex>;
    $[14] = t6;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t) {
    t10 = t("review.network");
    $[17] = t;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10) {
    t11 = <TextBody>{t10}</TextBody>;
    $[19] = t10;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== currency.chainIdentifier) {
    t12 = capitalize(currency.chainIdentifier);
    $[21] = currency.chainIdentifier;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== t12) {
    t13 = <TextBody><TextBody>{t12}</TextBody></TextBody>;
    $[23] = t12;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== t11 || $[26] !== t13) {
    t14 = <Flex className="justify-between">{t11}{t13}</Flex>;
    $[25] = t11;
    $[26] = t13;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <Separator orientation="horizontal" />;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== t) {
    t16 = t("review.total");
    $[29] = t;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] !== t16) {
    t17 = <TextBody weight="semibold">{t16}</TextBody>;
    $[31] = t16;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  const t18 = total || 0;
  let t19;
  if ($[33] !== t18) {
    t19 = <TextBody weight="semibold"><NumberDisplay display="usd" value={t18} /></TextBody>;
    $[33] = t18;
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  let t20;
  if ($[35] !== t17 || $[36] !== t19) {
    t20 = <Flex className="justify-between">{t17}{t19}</Flex>;
    $[35] = t17;
    $[36] = t19;
    $[37] = t20;
  } else {
    t20 = $[37];
  }
  let t21;
  if ($[38] !== t14 || $[39] !== t20 || $[40] !== t9) {
    t21 = <FlexColumn className="gap-4">{t9}{t14}{t15}{t20}</FlexColumn>;
    $[38] = t14;
    $[39] = t20;
    $[40] = t9;
    $[41] = t21;
  } else {
    t21 = $[41];
  }
  let t22;
  if ($[42] !== t2 || $[43] !== t21) {
    t22 = <FlexColumn className="gap-6 rounded-lg border border-border-1 bg-bg-additional-1 px-4 py-3 font-mono">{t2}{t21}</FlexColumn>;
    $[42] = t2;
    $[43] = t21;
    $[44] = t22;
  } else {
    t22 = $[44];
  }
  return t22;
}